// TableShimmer.js
import React from "react";

const TableShimmer = ({ columns = [], rows = 8 }) => {
  return (
    <div className="relative border border-[#eaebed] rounded-lg overflow-x-auto">
      <table className="min-w-[1200px] w-full text-sm">
        <thead className="bg-gray-100">
          <tr>
            {columns.map((col, idx) => (
              <th
                key={idx}
                className="px-3 py-1 border border-[#eaebed] text-left"
              >
                <div className="h-4 w-20 bg-gray-300 rounded relative overflow-hidden">
                  <div className="absolute top-0 left-0 h-full w-full bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 transform -translate-x-full animate-shimmer"></div>
                </div>
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {Array.from({ length: rows }).map((_, i) => (
            <tr
              key={i}
              className={`px-3 py-4 ${i % 2 === 0 ? "bg-white" : "bg-gradient-to-r from-gray-100 to-white"}`}
            >
              {columns.map((_, colIndex) => (
                <td
                  key={colIndex}
                  className="px-3 py-3 border border-[#eaebed]"
                >
                  <div className="h-4 w-full bg-gray-200 rounded relative overflow-hidden">
                    <div className="absolute top-0 left-0 h-full w-full bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 transform -translate-x-full animate-shimmer"></div>
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableShimmer;
